// import React, { useEffect, useState, useRef } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { useParams, useHistory } from "react-router-dom";
// import { toast } from "react-toastify";
// import {
//   fetchQuizzes,
//   postUserAnswer,
//   resetUserAnswersState,
//   setSelectedQuiz,
// } from "../store/reducers/quizzesSlice";
// import {
//   Typography,
//   FormControlLabel,
//   Button,
//   CircularProgress,
//   Checkbox,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Radio,
//   RadioGroup,
// } from "@mui/material";
// import { FaArrowLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import {
//   ACTION_CARD_COLORS,
//   getActionCardToneStyle,
// } from "../utils/actionCardColors";

// const getQuizTone = (quiz) => {
//   if (quiz?.video_id) return ACTION_CARD_COLORS.training;
//   if (quiz?.card_id) return ACTION_CARD_COLORS.read;
//   return ACTION_CARD_COLORS.incident;
// };

// /* ─── Inline styles ─────────────────────────────────────────────────────────── */
// const styles = {
//   page: {
//     minHeight: "100vh",
//     backgroundColor: "#f8f8f8",
//     padding: "24px 16px",
//     boxSizing: "border-box",
//     fontFamily: "'Inter', sans-serif",
//   },
//   header: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     marginBottom: "24px",
//     flexWrap: "wrap",
//   },
//   backBtn: {
//     display: "flex",
//     alignItems: "center",
//     gap: "6px",
//     padding: "8px 16px",
//     border: "1.5px solid #E05A4E",
//     borderRadius: "8px",
//     backgroundColor: "transparent",
//     color: "#E05A4E",
//     cursor: "pointer",
//     fontSize: "14px",
//     fontWeight: 500,
//     whiteSpace: "nowrap",
//   },
//   title: {
//     fontSize: "20px",
//     fontWeight: 700,
//     color: "#1a1a1a",
//     margin: 0,
//   },
//   langSelect: {
//     marginLeft: "auto",
//     padding: "6px 10px",
//     border: "1px solid #ddd",
//     borderRadius: "6px",
//     fontSize: "13px",
//     cursor: "pointer",
//     backgroundColor: "#fff",
//   },

//   /* ── layout wrapper ── */
//   layout: {
//     display: "flex",
//     gap: "24px",
//     alignItems: "flex-start",
//     flexWrap: "wrap",
//   },

//   /* ── question card (left) ── */
//   card: {
//     flex: "1 1 340px",
//     backgroundColor: "#fff",
//     border: "2px solid #E05A4E",
//     borderRadius: "16px",
//     padding: "28px 24px",
//     boxSizing: "border-box",
//     minWidth: 0,
//   },
//   questionLabel: {
//     fontSize: "20px",
//     fontWeight: 700,
//     color: "#1a1a1a",
//     marginBottom: "20px",
//     lineHeight: 1.4,
//   },
//   optionRow: {
//     display: "flex",
//     alignItems: "center",
//     gap: "12px",
//     padding: "14px 16px",
//     borderRadius: "10px",
//     border: "1.5px solid #e0e0e0",
//     marginBottom: "10px",
//     cursor: "pointer",
//     transition: "all 0.15s ease",
//     backgroundColor: "#fff",
//     userSelect: "none",
//   },
//   optionRowSelected: {
//     border: "1.5px solid #E05A4E",
//     backgroundColor: "#FEF0EF",
//   },
//   radioCircle: {
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     border: "2px solid #bbb",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//   },
//   radioCircleSelected: {
//     border: "2px solid #E05A4E",
//     backgroundColor: "#E05A4E",
//   },
//   radioInner: {
//     width: "8px",
//     height: "8px",
//     borderRadius: "50%",
//     backgroundColor: "#fff",
//   },
//   checkBox: {
//     width: "18px",
//     height: "18px",
//     borderRadius: "4px",
//     border: "2px solid #bbb",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     flexShrink: 0,
//   },
//   checkBoxSelected: {
//     border: "2px solid #E05A4E",
//     backgroundColor: "#E05A4E",
//   },
//   checkMark: {
//     color: "#fff",
//     fontSize: "11px",
//     lineHeight: 1,
//     fontWeight: 700,
//   },
//   optionLabel: {
//     fontSize: "15px",
//     color: "#1a1a1a",
//   },
//   optionLabelSelected: {
//     fontWeight: 600,
//     color: "#E05A4E",
//   },

//   /* ── bottom nav row ── */
//   navRow: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     marginTop: "24px",
//     flexWrap: "wrap",
//     gap: "12px",
//   },
//   submitBtn: {
//     padding: "10px 24px",
//     backgroundColor: "#E05A4E",
//     color: "#fff",
//     border: "none",
//     borderRadius: "8px",
//     fontSize: "15px",
//     fontWeight: 600,
//     cursor: "pointer",
//   },
//   submitBtnDisabled: {
//     opacity: 0.6,
//     cursor: "not-allowed",
//   },
//   arrowBtnGroup: {
//     display: "flex",
//     gap: "8px",
//   },
//   arrowBtn: {
//     width: "40px",
//     height: "40px",
//     border: "1.5px solid #ddd",
//     borderRadius: "8px",
//     backgroundColor: "#fff",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: "#444",
//     transition: "background 0.15s",
//   },
//   arrowBtnDisabled: {
//     opacity: 0.35,
//     cursor: "not-allowed",
//   },

//   /* ── progress panel (right) ── */
//   progressPanel: {
//     width: "260px",
//     flexShrink: 0,
//     backgroundColor: "#E05A4E",
//     borderRadius: "16px",
//     padding: "20px",
//     color: "#fff",
//     boxSizing: "border-box",
//   },
//   progressTrackWrap: {
//     marginBottom: "16px",
//   },
//   progressTrack: {
//     height: "6px",
//     borderRadius: "4px",
//     backgroundColor: "rgba(255,255,255,0.3)",
//     marginBottom: "14px",
//     overflow: "hidden",
//   },
//   progressFill: {
//     height: "100%",
//     borderRadius: "4px",
//     backgroundColor: "#fff",
//     transition: "width 0.3s ease",
//   },
//   progressRow: {
//     display: "flex",
//     justifyContent: "space-between",
//     fontSize: "14px",
//     marginBottom: "6px",
//     fontWeight: 500,
//   },

//   /* dot indicators */
//   dotsWrap: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "6px",
//     marginTop: "16px",
//   },
//   dot: {
//     width: "28px",
//     height: "28px",
//     borderRadius: "50%",
//     backgroundColor: "rgba(255,255,255,0.25)",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "11px",
//     fontWeight: 700,
//     color: "#fff",
//     cursor: "pointer",
//     transition: "background 0.15s",
//     border: "2px solid transparent",
//   },
//   dotAnswered: {
//     backgroundColor: "rgba(255,255,255,0.55)",
//   },
//   dotCurrent: {
//     backgroundColor: "#fff",
//     color: "#E05A4E",
//     border: "2px solid #fff",
//   },

//   loading: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     minHeight: "60vh",
//   },
// };

// /* ─── Component ─────────────────────────────────────────────────────────────── */
// const QuizDetail = () => {
//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const history = useHistory();

//   const { quizzes, selectedQuiz, userAnswers } = useSelector(
//     (state) => state.quizzes,
//   );

//   const [answers, setAnswers] = useState({});
//   const [quizData, setQuizData] = useState(null);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [language, setLanguage] = useState("en");
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const pendingNavigation = useRef(null);
//   const unblockRef = useRef(null);
//   const answersRef = useRef(answers);
//   const currentIndexRef = useRef(currentIndex);
//   const organizationId = localStorage.getItem("organisation_id");

//   // Keep refs in sync so history.block never has a stale closure
//   useEffect(() => {
//     answersRef.current = answers;
//   }, [answers]);
//   useEffect(() => {
//     currentIndexRef.current = currentIndex;
//   }, [currentIndex]);

//   /* ── data loading ── */
//   useEffect(() => {
//     if (selectedQuiz && selectedQuiz.id === id) {
//       setQuizData(selectedQuiz);
//     } else if (quizzes.data.length > 0) {
//       const found = quizzes.data.find((q) => q.id === id);
//       if (found) {
//         setQuizData(found);
//         dispatch(setSelectedQuiz(found));
//       }
//     } else {
//       dispatch(fetchQuizzes(organizationId));
//     }
//   }, [id, selectedQuiz, quizzes.data, dispatch, organizationId]);

//   /* ── navigation block — registered once, reads fresh values via refs ── */
//   useEffect(() => {
//     if (!quizData) return;

//     unblockRef.current = history.block((location) => {
//       const hasProgress =
//         Object.keys(answersRef.current).length > 0 ||
//         currentIndexRef.current > 0;

//       if (hasProgress) {
//         setOpenDialog(true);
//         pendingNavigation.current = location;
//         return false;
//       }
//       return true;
//     });

//     return () => {
//       if (unblockRef.current) unblockRef.current();
//     };
//   }, [quizData]); // only re-register when quizData loads

//   useEffect(() => {
//     const handleBeforeUnload = (e) => {
//       if (
//         quizData &&
//         Object.keys(answers).length !== quizData.questions.length
//       ) {
//         e.preventDefault();
//         e.returnValue = "";
//       }
//     };
//     window.addEventListener("beforeunload", handleBeforeUnload);
//     return () => window.removeEventListener("beforeunload", handleBeforeUnload);
//   }, [answers, quizData]);

//   if (quizzes.loading || !quizData) {
//     return (
//       <div style={styles.loading}>
//         <CircularProgress sx={{ color: "#E05A4E" }} />
//       </div>
//     );
//   }

//   const questions = quizData.questions || [];
//   const totalQuestions = questions.length;
//   const currentQuestion = questions[currentIndex];
//   const answeredCount = Object.keys(answers).length;
//   const progressPercent = totalQuestions
//     ? Math.round((answeredCount / totalQuestions) * 100)
//     : 0;

//   /* ── answer handling ── */
//   const handleChange = (qId, optionId, isMulti) => {
//     setAnswers((prev) => {
//       if (!isMulti) return { ...prev, [qId]: [optionId] };
//       const prevOptions = prev[qId] || [];
//       if (prevOptions.includes(optionId)) {
//         return { ...prev, [qId]: prevOptions.filter((o) => o !== optionId) };
//       }
//       return { ...prev, [qId]: [...prevOptions, optionId] };
//     });
//   };

//   /* ── navigation ── */
//   const goTo = (idx) => {
//     if (idx >= 0 && idx < totalQuestions) setCurrentIndex(idx);
//   };

//   const handleBackClick = () => {
//     // Show modal if user has answered anything OR navigated past the first question
//     const hasProgress = answeredCount > 0 || currentIndex > 0;
//     if (hasProgress) {
//       setOpenDialog(true);
//     } else {
//       history.push("/quizzes");
//     }
//   };

//   const handleConfirmLeave = () => {
//     setOpenDialog(false);
//     if (unblockRef.current) unblockRef.current();
//     history.push(pendingNavigation.current || "/quizzes");
//   };

//   const handleCancelLeave = () => {
//     setOpenDialog(false);
//     pendingNavigation.current = null;
//   };

//   /* ── submit ── */
//   const handleSubmit = async () => {
//     if (answeredCount !== totalQuestions) {
//       toast.error("Please answer all questions");
//       return;
//     }
//     dispatch(resetUserAnswersState());
//     const formattedAnswers = Object.keys(answers).map((qId) => ({
//       question_id: Number(qId),
//       ids: answers[qId],
//     }));
//     let payload = {
//       organization_id: +organizationId,
//       answers: formattedAnswers,
//     };
//     if (quizData.video_id) payload.video_id = quizData.video_id;
//     else if (quizData.card_id) payload.card_id = quizData.card_id;
//     else if (quizData.quiz_id) payload.quiz_id = quizData.quiz_id;

//     const response = await dispatch(postUserAnswer(payload));
//     if (postUserAnswer.rejected.match(response)) {
//       toast.error(
//         response.payload?.error ||
//           response.payload?.message ||
//           "Quiz submission failed",
//       );
//       return;
//     }
//     const message = response.payload?.message || "Quiz submitted successfully";
//     message.toLowerCase().includes("fail")
//       ? toast.error(message)
//       : toast.success(message);
//     if (unblockRef.current) unblockRef.current();
//     history.push("/quizzes");
//   };

//   const isSelected = (qId, optId) => answers[qId]?.includes(optId) || false;

//   /* ─── render ─────────────────────────────────────────────────────────────── */
//   return (
//     <div style={styles.page}>
//       {/* Header */}
//       <div style={styles.header}>
//         <button style={styles.backBtn} onClick={handleBackClick}>
//           <FaArrowLeft size={13} />
//           Back
//         </button>
//         <h1 style={styles.title}>{quizData.displayName}</h1>
//         <select
//           value={language}
//           onChange={(e) => setLanguage(e.target.value)}
//           style={styles.langSelect}
//           aria-label="Quiz language"
//         >
//           <option value="en">English</option>
//           <option value="dk">Danish</option>
//         </select>
//       </div>

//       {/* Two-column layout */}
//       <div style={styles.layout}>
//         {/* ── Question Card ── */}
//         <div style={styles.card}>
//           <div style={styles.questionLabel}>
//             Q{currentIndex + 1}:{" "}
//             {language === "en"
//               ? currentQuestion.question
//               : currentQuestion.question_dk || currentQuestion.question}
//           </div>

//           {/* Options */}
//           <div>
//             {currentQuestion.correct_answers === 1
//               ? currentQuestion.options?.map((opt) => {
//                   const selected = isSelected(currentQuestion.id, opt.id);
//                   return (
//                     <div
//                       key={opt.id}
//                       style={{
//                         ...styles.optionRow,
//                         ...(selected ? styles.optionRowSelected : {}),
//                       }}
//                       onClick={() =>
//                         handleChange(currentQuestion.id, opt.id, false)
//                       }
//                     >
//                       <div
//                         style={{
//                           ...styles.radioCircle,
//                           ...(selected ? styles.radioCircleSelected : {}),
//                         }}
//                       >
//                         {selected && <div style={styles.radioInner} />}
//                       </div>
//                       <span
//                         style={{
//                           ...styles.optionLabel,
//                           ...(selected ? styles.optionLabelSelected : {}),
//                         }}
//                       >
//                         {language === "en"
//                           ? opt.text_en
//                           : opt.text_dk || opt.text_en}
//                       </span>
//                     </div>
//                   );
//                 })
//               : currentQuestion.options?.map((opt) => {
//                   const selected = isSelected(currentQuestion.id, opt.id);
//                   return (
//                     <div
//                       key={opt.id}
//                       style={{
//                         ...styles.optionRow,
//                         ...(selected ? styles.optionRowSelected : {}),
//                       }}
//                       onClick={() =>
//                         handleChange(currentQuestion.id, opt.id, true)
//                       }
//                     >
//                       <div
//                         style={{
//                           ...styles.checkBox,
//                           ...(selected ? styles.checkBoxSelected : {}),
//                         }}
//                       >
//                         {selected && <span style={styles.checkMark}>✓</span>}
//                       </div>
//                       <span
//                         style={{
//                           ...styles.optionLabel,
//                           ...(selected ? styles.optionLabelSelected : {}),
//                         }}
//                       >
//                         {language === "en"
//                           ? opt.text_en
//                           : opt.text_dk || opt.text_en}
//                       </span>
//                     </div>
//                   );
//                 })}
//           </div>

//           {/* Nav row */}
//           <div style={styles.navRow}>
//             <button
//               style={{
//                 ...styles.submitBtn,
//                 ...(userAnswers.loading ? styles.submitBtnDisabled : {}),
//               }}
//               onClick={handleSubmit}
//               disabled={userAnswers.loading}
//             >
//               {userAnswers.loading ? "Submitting…" : "Submit Quiz"}
//             </button>

//             <div style={styles.arrowBtnGroup}>
//               <button
//                 style={{
//                   ...styles.arrowBtn,
//                   ...(currentIndex === 0 ? styles.arrowBtnDisabled : {}),
//                 }}
//                 onClick={() => goTo(currentIndex - 1)}
//                 disabled={currentIndex === 0}
//                 aria-label="Previous question"
//               >
//                 <FaChevronLeft size={13} />
//               </button>
//               <button
//                 style={{
//                   ...styles.arrowBtn,
//                   ...(currentIndex === totalQuestions - 1
//                     ? styles.arrowBtnDisabled
//                     : {}),
//                 }}
//                 onClick={() => goTo(currentIndex + 1)}
//                 disabled={currentIndex === totalQuestions - 1}
//                 aria-label="Next question"
//               >
//                 <FaChevronRight size={13} />
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* ── Progress Panel ── */}
//         <div style={styles.progressPanel}>
//           {/* Progress bar */}
//           <div style={styles.progressTrackWrap}>
//             <div style={styles.progressTrack}>
//               <div
//                 style={{ ...styles.progressFill, width: `${progressPercent}%` }}
//               />
//             </div>
//             <div style={styles.progressRow}>
//               <span>Questions Answered</span>
//               <strong>
//                 {answeredCount} / {totalQuestions}
//               </strong>
//             </div>
//             <div style={styles.progressRow}>
//               <span>Current Score</span>
//               <strong>{progressPercent}%</strong>
//             </div>
//           </div>

//           {/* Question dots */}
//           <div style={styles.dotsWrap}>
//             {questions.map((_, idx) => {
//               const answered = !!answers[questions[idx].id];
//               const isCurrent = idx === currentIndex;
//               return (
//                 <div
//                   key={idx}
//                   style={{
//                     ...styles.dot,
//                     ...(answered ? styles.dotAnswered : {}),
//                     ...(isCurrent ? styles.dotCurrent : {}),
//                   }}
//                   onClick={() => goTo(idx)}
//                   title={`Question ${idx + 1}`}
//                 >
//                   {idx + 1}
//                 </div>
//               );
//             })}
//           </div>
//         </div>
//       </div>

//       {/* Responsive styles */}
//       <style>{`
//         @media (max-width: 640px) {
//           .quiz-layout-wrap { flex-direction: column-reverse !important; }
//           .quiz-progress-panel { width: 100% !important; }
//         }
//       `}</style>

//       {/* Leave dialog */}
//       <Dialog
//         open={openDialog}
//         onClose={handleCancelLeave}
//         PaperProps={{ className: "ac-leave-dialog" }}
//       >
//         <DialogTitle>Leave Quiz?</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Are you sure you want to leave the quiz? Your progress will be lost.
//           </Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCancelLeave}>No</Button>
//           <Button color="error" onClick={handleConfirmLeave}>
//             Yes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default QuizDetail;

import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  fetchQuizzes,
  postUserAnswer,
  resetUserAnswersState,
  setSelectedQuiz,
} from "../store/reducers/quizzesSlice";
import {
  Typography,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { FaArrowLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { ACTION_CARD_COLORS } from "../utils/actionCardColors";

const getQuizTone = (quiz) => {
  if (quiz?.video_id) return ACTION_CARD_COLORS.training;
  if (quiz?.card_id) return ACTION_CARD_COLORS.read;
  return ACTION_CARD_COLORS.incident;
};

/* ─── Component ─────────────────────────────────────────────────────────────── */
const QuizDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const { quizzes, selectedQuiz, userAnswers } = useSelector(
    (state) => state.quizzes,
  );

  const [answers, setAnswers] = useState({});
  const [quizData, setQuizData] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [language, setLanguage] = useState("en");
  const [currentIndex, setCurrentIndex] = useState(0);

  const pendingNavigation = useRef(null);
  const unblockRef = useRef(null);
  const answersRef = useRef(answers);
  const currentIndexRef = useRef(currentIndex);
  const organizationId = localStorage.getItem("organisation_id");

  useEffect(() => {
    answersRef.current = answers;
  }, [answers]);
  useEffect(() => {
    currentIndexRef.current = currentIndex;
  }, [currentIndex]);

  /* ── data loading ── */
  useEffect(() => {
    if (selectedQuiz && selectedQuiz.id === id) {
      setQuizData(selectedQuiz);
    } else if (quizzes.data.length > 0) {
      const found = quizzes.data.find((q) => q.id === id);
      if (found) {
        setQuizData(found);
        dispatch(setSelectedQuiz(found));
      }
    } else {
      dispatch(fetchQuizzes(organizationId));
    }
  }, [id, selectedQuiz, quizzes.data, dispatch, organizationId]);

  /* ── navigation block ── */
  useEffect(() => {
    if (!quizData) return;

    unblockRef.current = history.block((location) => {
      const hasProgress =
        Object.keys(answersRef.current).length > 0 ||
        currentIndexRef.current > 0;

      if (hasProgress) {
        setOpenDialog(true);
        pendingNavigation.current = location;
        return false;
      }
      return true;
    });

    return () => {
      if (unblockRef.current) unblockRef.current();
    };
  }, [quizData]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (
        quizData &&
        Object.keys(answers).length !== quizData.questions.length
      ) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [answers, quizData]);

  if (quizzes.loading || !quizData) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <CircularProgress sx={{ color: "#E05A4E" }} />
      </div>
    );
  }

  const questions = quizData.questions || [];
  const totalQuestions = questions.length;
  const currentQuestion = questions[currentIndex];
  const answeredCount = Object.keys(answers).length;
  const progressPercent = totalQuestions
    ? Math.round((answeredCount / totalQuestions) * 100)
    : 0;

  /* ── answer handling ── */
  const handleChange = (qId, optionId, isMulti) => {
    setAnswers((prev) => {
      if (!isMulti) return { ...prev, [qId]: [optionId] };
      const prevOptions = prev[qId] || [];
      if (prevOptions.includes(optionId)) {
        return { ...prev, [qId]: prevOptions.filter((o) => o !== optionId) };
      }
      return { ...prev, [qId]: [...prevOptions, optionId] };
    });
  };

  /* ── navigation ── */
  const goTo = (idx) => {
    if (idx >= 0 && idx < totalQuestions) setCurrentIndex(idx);
  };

  const handleBackClick = () => {
    const hasProgress = answeredCount > 0 || currentIndex > 0;
    if (hasProgress) {
      setOpenDialog(true);
    } else {
      history.push("/quizzes");
    }
  };

  const handleConfirmLeave = () => {
    setOpenDialog(false);
    if (unblockRef.current) unblockRef.current();
    history.push(pendingNavigation.current || "/quizzes");
  };

  const handleCancelLeave = () => {
    setOpenDialog(false);
    pendingNavigation.current = null;
  };

  /* ── submit ── */
  const handleSubmit = async () => {
    if (answeredCount !== totalQuestions) {
      toast.error("Please answer all questions");
      return;
    }
    dispatch(resetUserAnswersState());
    const formattedAnswers = Object.keys(answers).map((qId) => ({
      question_id: Number(qId),
      ids: answers[qId],
    }));
    let payload = {
      organization_id: +organizationId,
      answers: formattedAnswers,
    };
    if (quizData.video_id) payload.video_id = quizData.video_id;
    else if (quizData.card_id) payload.card_id = quizData.card_id;
    else if (quizData.quiz_id) payload.quiz_id = quizData.quiz_id;

    const response = await dispatch(postUserAnswer(payload));
    if (postUserAnswer.rejected.match(response)) {
      toast.error(
        response.payload?.error ||
          response.payload?.message ||
          "Quiz submission failed",
      );
      return;
    }
    const message = response.payload?.message || "Quiz submitted successfully";
    message.toLowerCase().includes("fail")
      ? toast.error(message)
      : toast.success(message);
    if (unblockRef.current) unblockRef.current();
    history.push("/quizzes");
  };

  const isSelected = (qId, optId) => answers[qId]?.includes(optId) || false;

  /* ─── render ─────────────────────────────────────────────────────────────── */
  return (
    <div className="min-h-screen bg-gray-100 p-4 sm:p-6 font-sans box-border">
      {/* ── Header ── */}
      <div className="flex items-center gap-3 mb-6 flex-wrap">
        <button
          onClick={handleBackClick}
          className="flex items-center gap-2 px-4 py-2 border border-[#E05A4E] text-[#E05A4E] rounded-lg bg-transparent text-sm font-medium cursor-pointer whitespace-nowrap hover:bg-[#FEF0EF] transition-colors"
        >
          <FaArrowLeft size={13} />
          Back
        </button>
        <h1 className="text-xl font-bold text-gray-900 m-0">
          {quizData.displayName}
        </h1>
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          aria-label="Quiz language"
          className="ml-auto px-3 py-1.5 border border-gray-300 rounded-md text-sm cursor-pointer bg-white focus:outline-none focus:ring-2 focus:ring-[#E05A4E]"
        >
          <option value="en">English</option>
          <option value="dk">Danish</option>
        </select>
      </div>

      {/* ── Two-column layout ── */}
      <div className="flex gap-3 items-start flex-wrap">
        {/* ── Question Card ── */}
        <div className="flex-1 min-w-[300px] bg-white border-2 border-[#E05A4E] rounded-2xl p-6 sm:p-7 box-border">
          {/* Question text */}
          <div className="text-lg sm:text-xl font-bold text-gray-900 mb-5 leading-snug">
            Q{currentIndex + 1}:{" "}
            {language === "en"
              ? currentQuestion.question
              : currentQuestion.question_dk || currentQuestion.question}
          </div>

          {/* Options */}
          <div className="flex flex-col gap-2.5">
            {currentQuestion.correct_answers === 1
              ? currentQuestion.options?.map((opt) => {
                  const selected = isSelected(currentQuestion.id, opt.id);
                  return (
                    <div
                      key={opt.id}
                      onClick={() =>
                        handleChange(currentQuestion.id, opt.id, false)
                      }
                      className={`flex items-center gap-3 px-4 py-3.5 rounded-xl border cursor-pointer select-none transition-all duration-150
                        ${
                          selected
                            ? "border-[#E05A4E] bg-[#FEF0EF]"
                            : "border-gray-200 bg-white hover:border-gray-300"
                        }`}
                    >
                      {/* Radio circle */}
                      <div
                        className={`flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full border-2 transition-colors ${
                          selected
                            ? "border-[#E05A4E] bg-[#E05A4E]"
                            : "border-white bg-black"
                        }`}
                      >
                        {selected ? (
                          <div className="h-2 w-2 rounded-full bg-white" />
                        ) : (
                          <div className="h-3 w-3 rounded-full bg-white" />
                        )}
                      </div>
                      <span
                        className={`text-sm sm:text-base transition-colors
                          ${
                            selected
                              ? "font-semibold text-[#E05A4E]"
                              : "text-gray-900"
                          }`}
                      >
                        {language === "en"
                          ? opt.text_en
                          : opt.text_dk || opt.text_en}
                      </span>
                    </div>
                  );
                })
              : currentQuestion.options?.map((opt) => {
                  const selected = isSelected(currentQuestion.id, opt.id);
                  return (
                    <div
                      key={opt.id}
                      onClick={() =>
                        handleChange(currentQuestion.id, opt.id, true)
                      }
                      className={`flex items-center gap-3 px-4 py-3.5 rounded-xl border cursor-pointer select-none transition-all duration-150
                        ${
                          selected
                            ? "border-[#E05A4E] bg-[#FEF0EF]"
                            : "border-gray-200 bg-white hover:border-gray-300"
                        }`}
                    >
                      {/* Checkbox */}
                      <div
                        className={`flex h-[18px] w-[18px] items-center justify-center rounded-[4px] border-2 ${
                          selected
                            ? "border-[#E05A4E] bg-[#E05A4E]"
                            : "border !border-black bg-[#f8dfdf]"
                        }`}
                      >
                        {selected && (
                          <span className="text-[11px] font-bold leading-none text-white">
                            ✓
                          </span>
                        )}
                      </div>
                      <span
                        className={`text-sm sm:text-base transition-colors
                          ${
                            selected
                              ? "font-semibold text-[#E05A4E]"
                              : "text-gray-900"
                          }`}
                      >
                        {language === "en"
                          ? opt.text_en
                          : opt.text_dk || opt.text_en}
                      </span>
                    </div>
                  );
                })}
          </div>

          {/* ── Nav row ── */}
          <div className="flex items-center justify-between mt-6 flex-wrap gap-3">
            <button
              onClick={handleSubmit}
              disabled={userAnswers.loading}
              className={`px-6 py-2.5 bg-[#E05A4E] text-white rounded-lg text-sm sm:text-base font-semibold border-none cursor-pointer transition-opacity
                ${
                  userAnswers.loading
                    ? "opacity-60 cursor-not-allowed"
                    : "hover:opacity-90"
                }`}
            >
              {userAnswers.loading ? "Submitting…" : "Submit Quiz"}
            </button>

            <div className="flex gap-2">
              <button
                onClick={() => goTo(currentIndex - 1)}
                disabled={currentIndex === 0}
                aria-label="Previous question"
                className={`w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg bg-white text-gray-600 cursor-pointer transition-colors
                  ${
                    currentIndex === 0
                      ? "opacity-35 cursor-not-allowed"
                      : "hover:bg-gray-50"
                  }`}
              >
                <FaChevronLeft size={13} />
              </button>
              <button
                onClick={() => goTo(currentIndex + 1)}
                disabled={currentIndex === totalQuestions - 1}
                aria-label="Next question"
                className={`w-10 h-10 flex items-center justify-center border border-gray-300 rounded-lg bg-white text-gray-600 cursor-pointer transition-colors
                  ${
                    currentIndex === totalQuestions - 1
                      ? "opacity-35 cursor-not-allowed"
                      : "hover:bg-gray-50"
                  }`}
              >
                <FaChevronRight size={13} />
              </button>
            </div>
          </div>
        </div>

        {/* ── Progress Panel ── */}
        <div className="w-full sm:w-[260px] flex-shrink-0 bg-[#F6605F] rounded-2xl px-3 py-4 text-white box-border">
          {/* Progress bar */}
          <div className="h-1.5 rounded-full bg-white/30 mb-4 overflow-hidden">
            <div
              className="h-full rounded-full bg-white transition-all duration-300"
              style={{ width: `${progressPercent}%` }}
            />
          </div>

          {/* Stats */}
          <div className="flex justify-between text-sm text-white font-medium mb-1.5">
            <span className="text-white">Questions Answered</span>
            <strong>
              {answeredCount} / {totalQuestions}
            </strong>
          </div>
          <div className="flex justify-between text-sm font-medium text-white">
            <span className="text-white">Current Score</span>
            <strong>{progressPercent}%</strong>
          </div>

          {/* Question dots */}
          <div className="flex flex-wrap gap-1.5 mt-4">
            {questions.map((q, idx) => {
              const answered = !!answers[q.id];
              const isCurrent = idx === currentIndex;
              return (
                <div
                  key={idx}
                  onClick={() => goTo(idx)}
                  title={`Question ${idx + 1}`}
                  className={`w-7 h-7 rounded-full flex items-center justify-center text-[11px] font-bold text-white cursor-pointer transition-all border-2
                    ${
                      isCurrent
                        ? "bg-white !text-[#E05A4E] border-white"
                        : answered
                        ? "bg-white/55 border-transparent"
                        : "bg-white/25 border-transparent hover:bg-white/35"
                    }`}
                >
                  {idx + 1}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* ── Leave Dialog ── */}
      <Dialog
        open={openDialog}
        onClose={handleCancelLeave}
        PaperProps={{ className: "rounded-2xl" }}
      >
        <DialogTitle className="font-bold text-gray-900">
          Leave Quiz?
        </DialogTitle>
        <DialogContent>
          <Typography className="text-gray-600">
            Are you sure you want to leave the quiz? Your progress will be lost.
          </Typography>
        </DialogContent>
        <DialogActions className="px-4 pb-4 gap-2">
          <Button
            onClick={handleConfirmLeave}
            sx={{
              color: "#1976d2",
              textTransform: "none",
              background: "none",
              border: "none",
              boxShadow: "none",
              "&:hover": { background: "none" },
            }}
          >
            Yes
          </Button>
          <Button
            onClick={handleCancelLeave}
            sx={{
              color: "#E05A4E",
              textTransform: "none",
              background: "none",
              border: "none",
              boxShadow: "none",
              "&:hover": { background: "none" },
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default QuizDetail;
